import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export const addToCart = async (userId: string, productId: string) => {
  console.log("Product ID:", productId); 
  const cartDocRef = doc(db, "cart", userId);
  try {
    const docSnap = await getDoc(cartDocRef);
    if (docSnap.exists()) {
      await updateDoc(cartDocRef, {
        [productId]: true,
      });
    } else {
      await setDoc(cartDocRef, {
        [productId]: true,
      });
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

export default addToCart;
